import { render, staticRenderFns } from "./LeadsTable.vue?vue&type=template&id=4d0230fe&scoped=true"
import script from "./LeadsTable.vue?vue&type=script&lang=js"
export * from "./LeadsTable.vue?vue&type=script&lang=js"
import style0 from "./LeadsTable.vue?vue&type=style&index=0&id=4d0230fe&prod&scoped=true&lang=css"
import style1 from "./LeadsTable.vue?vue&type=style&index=1&id=4d0230fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0230fe",
  null
  
)

export default component.exports